const fitTypes = ["COVER", "CONTAIN", "FILL", "NONE"] as const;
type FitType = typeof fitTypes[number];

export { fitTypes };
export type { FitType };
